<template>
  <div>

    <div class="row">
      <div class="col-12"  v-if="isBCBA || isCurator">

        <div class="filter-row d-flex h-100  flex-wrap align-items-end justify-content-between justify-content-sm-start">
          <div class="datepicker">
              <span class="datepicker__label">
                   {{'behavior.date_start' | trans }}
              </span>

            <v-date-picker
                v-model='rangeDateStart'
                name="rangeDateStart"
                :formats='formats'
                title-position="left"
                :input-props='{ readonly: true }'
                :max-date=maxDateStart
                v-validate="'required|check-period'"
                data-vv-validate-on="none"
                :class="{'is-invalid': errors.has('rangeDateStart')}"
                :min-date="minDateStart">
            </v-date-picker>

            <mdc-icon icon="date_range"></mdc-icon>

          </div>

          <div class="datepicker right">
              <span class="datepicker__label">
                   {{'appeals.date_end' | trans }}
              </span>

            <v-date-picker
                v-model='rangeDateEnd'
                :formats='formats'
                title-position="left"
                :input-props='{ readonly: true }'
                :min-date="rangeDateStart">
            </v-date-picker>

            <mdc-icon icon="date_range"></mdc-icon>
          </div>
          <div class="item-filter mr-md-4">
            <v-select v-model="quiz"
                      :class="{'is-invalid': errors.has('field'), 'is-clear': !quiz}"
                      :options="quizList"
                      label="title"
                      name="quiz"
                      :filterable="false"
                      data-vv-validate-on="none">
            </v-select>
            <label class="mdc-floating-label">{{'quiz.quiz' | trans}}</label>
          </div>

          <div class="item-filter mr-md-4 mb-0">
            <autocomplete-search
                :class="{'is-invalid': errors.has('targetBehaviour')}"
                id="targetBehaviour"
                ref="targetBehaviour"
                v-model="targetBehaviour"
                :suggestions="autocomplete"
                :visible="visible"
                :field="'name'"
                :label="'quiz.targetBahaviour' | trans"
                validateRule=""
                validateLable=""
                v-on:input="setProblemBehaviourValue"
                v-on:inputChange="onChangeProblemBehaviour">
            </autocomplete-search>
            <span class="invalid-feedback" v-if="errors.has('targetBehaviour')">
                  <strong>{{ errors.first('targetBehaviour') }}</strong>
                </span>
          </div>

        </div>
      </div>

      <div class="col-12 mt-0  d-lg-block" v-if="isBCBA || isCurator">
        <div :class="{'d-flex h-100  align-items-end justify-content-end': !isMobile}">

          <button type="button"
                  class="btn btn-lightblue mt-3 mt-sm-0 mb-2 mr-2" raised
                  @click.prevent="applyFilter()">
            {{'behavior.buttons.apply' | trans }}
          </button>


          <button type="button" class="btn btn-light mb-2 mr-2"
                  :disabled="(!fastList || (fastList && fastList.unitIds.length < 2)) && (!masList || (masList && masList.unitIds.length < 2))"
                  raised
                  @click.prevent="showResult()">
            {{'report.report' | trans }}
          </button>

          <button type="button" class="btn btn-light mb-2 mr-2"
                  :disabled="(!fastList || (fastList && fastList.unitIds.length < 2)) && (!masList || (masList && masList.unitIds.length < 2))"
                  raised
                  @click.prevent="exportQuiz()">
            {{'quiz.pdfReport' | trans }}
          </button>

          <router-link class="btn btn-primary mb-2"
                       :to="{ name: 'quiz-create', params: {clientId: clientId}}">
            {{'quiz.createQuiz' | trans }}
          </router-link>

        </div>
      </div>

      <div class="col-12 mb-3 mt-2" :class="{'table-without-header':isMobile, 'table-hide-head':isTherapist}">
        <div class="text-danger mb-2" v-if="messageError">{{messageError}}</div>
        <table-view
            :options="options"
            :withChild="isBCBA || isCurator"
            :isList=isMobile
            indexColumn="4"
            :isLoaded="isLoaded"
            :isChange="isChange"
        >

          <div slot="childRow" slot-scope="props">
            <div class="p-3" v-if="(isCurator && user.id === props.row.creator.id) || isBCBA">
              <table class="table table-sm">
                <thead class="thead-light">
                <tr>
                  <th>{{'quiz.quizComplete' | trans}}</th>
                  <th class="nowrap">{{'quiz.passed_at' | trans}}</th>
                  <th class="text-center">{{'quiz.addToReport' | trans}}</th>
                  <th></th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                  <tr  v-for="specialists in props.row.quizAnsweredUnits" :key="specialists.id" >
                    <td>{{specialists.name}}</td>
                    <td class="nowrap">{{specialists.passedAt ? toLocaleDateTime(specialists.passedAt.date) : ''}}</td>
                    <td class="text-center"><mdc-checkbox v-model="specialists.addAnsweredToReport"
                                                          @change="choseSpecialists(props.row,specialists)"
                                                          :disabled="!specialists.addAnsweredToReport && ((listReportLength(props.row.quizAnsweredSpecialists) > 2) || disabledCheckAnswer(props.row))"/>
                    </td>
                    <td>
                      <div>
                        <a href="" class="nav-link"
                           @click.prevent="exportSpecialistQuiz(props.row.id, specialists.id)">{{'quiz.pdfReport' | trans }}</a>
                      </div>
                    </td>
                    <td>
                      <div>
                        <a href="" class="nav-link"
                           @click.prevent="resultSpecialistQuiz(props.row.id, specialists.id)">{{'report.report' | trans }}</a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div slot="quizAssignedUnits" slot-scope="props">
            <b v-if="isMobile">{{'quiz.assigned' | trans}}:</b>
            <div v-for="specialist in props.row.quizAssignedUnits" class="d-flex">
              {{specialist.name}}
              <i v-if="specialist.isAnswered" class="material-icons text-success align-middle fz16">done</i>
            </div>
          </div>

          <div slot="childList" slot-scope="props">
            <div >
              <table class="table table-sm">
                <thead class="thead-light">
                <tr>
                  <th>{{'quiz.quizComplete' | trans}}</th>
                  <th class="nowrap">{{'quiz.passed_at' | trans}}</th>
                  <th class="text-center">{{'quiz.addToReport' | trans}}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr  v-for="specialists in props.row.quizAnsweredUnits" :key="specialists.id" >
                  <td>{{specialists ? specialists.name: ''}}</td>
                  <td class="nowrap">{{specialists.passedAt ? toLocaleDate(specialists.passedAt.date) : ''}}</td>
                  <td class="text-center"><mdc-checkbox v-model="specialists.addAnsweredToReport"
                                                        @change="choseSpecialists(props.row,specialists)"
                                                        :disabled="!specialists.addAnsweredToReport && ((listReportLength(props.row.quizAnsweredSpecialists) > 2) || disabledCheckAnswer(props.row))"/>
                  </td>
                  <td>
                    <div>
                      <a href="" class="nav-link"
                         @click.prevent="exportSpecialistQuiz(props.row.id, specialists.id)">{{'quiz.pdfReport' | trans }}</a>
                    </div>
                    <div>
                      <a href="" class="nav-link"
                         @click.prevent="resultSpecialistQuiz(props.row.id, specialists.id)">{{'report.report' | trans }}</a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div slot="action" slot-scope="props">
            <div class="actions" v-if="isBCBA || isCurator">
              <mdc-menu-anchor>
                <mdc-button raised @click="props.row.isOpen = true">
                  <i class="material-icons">more_vert</i>
                </mdc-button>

                <mdc-menu v-model="props.row.isOpen">
                  <mdc-menu-item>
                    <router-link class="nav-link" :to="{ name: 'quiz-show', params: {clientId: clientId, quizId: props.row.id }}">
                      {{'quiz.show' | trans}}
                    </router-link>
                  </mdc-menu-item>
                  <mdc-menu-item v-if="(!props.row.quizAnsweredUnits.length || props.row.specialist.isDeleted) && ((isCurator && user.id === props.row.creator.id) || isBCBA)" >
                    <router-link class="nav-link" :to="{ name: 'quiz-edit', params: {clientId: clientId, quizId: props.row.id }}">
                      {{'protocol.buttons.edit' | trans}}
                    </router-link>
                  </mdc-menu-item>
                  <mdc-menu-item>
                    <router-link class="nav-link" v-if="props.row.specialist && user.id === props.row.specialist.id  && (props.row.quizAssignedUnits.length !== props.row.quizAnsweredUnits.length)" :to="{ name: 'quiz-take', params: {clientId: clientId, quizId: props.row.id }}">
                      {{'quiz.take' | trans}}
                    </router-link>
                  </mdc-menu-item>
                  <mdc-menu-item v-if="!props.row.quizAnsweredUnits.length && ((isCurator && user.id === props.row.creator.id) || isBCBA)">
                    <a href="" class="nav-link"
                       @click.prevent="showDeletePopup(props.row)">{{'protocol.buttons.delete' | trans }}</a>
                  </mdc-menu-item>
                </mdc-menu>
              </mdc-menu-anchor>
            </div>
            <div v-if="isTherapist" class="nowrap">
              <router-link class="nav-link" :to="{ name: 'quiz-take', params: {clientId: clientId, quizId: props.row.id }}">
                {{'quiz.goToQuiz' | trans}}
              </router-link>
            </div>
          </div>

          <div slot="addToReport" slot-scope="props" v-if="isBCBA || isCurator">
            <mdc-checkbox disabled :checked="!!listReportLength(props.row.quizAnsweredUnits)"/>
          </div>

        </table-view>
      </div>
    </div>

    <div class="col-12 mt-4 position-relative" ref="resultTable" id="resultTable">

      <div class="row" v-for="result in results">
        <div class="col-12" v-if="result.quiz.id === 1">
          <h3 class="row-title">{{'quiz.masTableTitle' | trans}} ({{result.assignedQuizUnit.name}})</h3>
          <table class="table table-bordered table-sm">
            <thead class="thead-light">
            <tr>
              <th></th>
              <th v-for="(title, index) in result.resultTable.titles[0]" class="text-center">{{title}}</th>
            </tr>
            </thead>
            <tbody>

              <tr v-for="answers in result.resultTable.questionAnswers">
                <td></td>
                <td v-for="answer in answers" class="text-center">
                  <strong class="float-left mw20">{{answer.questionId}}.</strong> {{answer.value}}
                </td>
              </tr>

              <tr v-for="(answersTotal, indexTotal) in result.resultTable.totalScore">
                <td v-if="indexTotal == 5">{{'quiz.totalScore' | trans}}</td>
                <td v-if="indexTotal == 6">{{'quiz.meanScore' | trans}} <i>{{'quiz.meanScoreDescription' | trans}}</i></td>
                <td v-if="indexTotal == 7">{{'quiz.relativeRanking' | trans}} <i>{{'quiz.relativeRankingDescription' | trans}}</i></td>
                <td v-for="answer in answersTotal" class="text-center">
                  {{answer}}
                </td>
              </tr>

            </tbody>
          </table>
        </div>
        <div class="col-12" v-if="result.quiz.id === 2">
          <h3 class="row-title">{{'quiz.fastTableTitle' | trans}} ({{result.assignedQuizUnit.name}})</h3>
          <table class="table table-bordered table-sm">
            <thead class="thead-light">
            <tr>
              <th v-for="(title, index) in result.resultTable.titles" :class="{'text-center': (index===1)}" :colspan="index===0 ? result.resultTable.questionAnswers[0].length : 1">{{title}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(answers, index) in result.resultTable.questionAnswers">
              <td v-for="(answer, answIndex) in answers" class="text-center" :class="{'bg-secondary': answer.value === 1}">
                {{answer.questionId - 22}}
              </td>
              <td v-if="index === 4 || index === 3"></td>
              <td v-if="index === 4 || index === 3"></td>
              <td class="text-center">
                {{result.resultTable.totalScore[index]}}
              </td>
              <td :class="{'bg-secondary': result.resultTable.totalScore[index] === maxValue(result.resultTable.totalScore)}">
                {{result.resultTable.title[index]}}
              </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>

    <div class="col-12 mt-3" v-if="barChartDatasetMas.length && maxMas">
      <bar-chart :bardatasets="dataMas"
                 scaleLabelX=""
                 :scaleLabelY="'quiz.meanScore' | trans"
                 :withLabels="true"
                 :showLegend="results.length>1"
                 :aspectRatio="false"
                 :height="360"
                 :valueMax="maxMas"
                 v-bind:show-legend="true"/>
      <h4 class="chart__title mb-3">{{results.length>1 ? 'quiz.masChart' : 'quiz.oneMasChart' | trans}}</h4>
    </div>

    <div class="col-12 mt-3" v-if="barChartDatasetFast.length && maxFast">

      <bar-chart :bardatasets="dataFast"
                 scaleLabelX=""
                 :scaleLabelY="'quiz.countYes' | trans"
                 :withLabels="true"
                 :aspectRatio="false"
                 :height="360"
                 :showLegend="results.length>1"
                 :valueMax="maxFast"
                 v-bind:show-legend="true"/>
      <h4 class="chart__title mb-3">{{results.length>1 ? 'quiz.fastChart' : 'quiz.oneFastChart' | trans}}</h4>
    </div>

    <mdc-dialog v-model="isModalVisible"
                :title="'user.confirm_delete' | trans"
                :accept="'user.delete' | trans"
                :cancel="'user.cancel' | trans"
                @accept="deleteQuiz(quizSelectedToDelete)"
                @cancel="onModalClose">

    </mdc-dialog>

    <mdc-dialog v-model="isModalErrorVisible"
                :title="'quiz.errorDelete' | trans"
                :accept="'user.close' | trans"
                @accept="onModalErrorClose"/>


  </div>
</template>

<script>
  import axios from 'axios';
  import lang from '../../../lang/translator';
  import filter from 'lodash/filter';
  import findIndex from 'lodash/findIndex';
  import join from 'lodash/join';
  import map from 'lodash/map'
  import max from 'lodash/max'
  import forEach from 'lodash/forEach'
  import Paginate from 'vuejs-paginate';
  import Loader from '../../loader/components/Loader';
  import TableView from '../../../common/table/components/TableView';
  import {mapGetters} from 'vuex';
  import moment from 'moment';
  import {Validator} from 'vee-validate';
  import Constants from '../../undesirableBehavior/Constants';
  import {
    BarChart,
    BarChartDataset,
  } from '../../../common/chart';
  import debounce from 'lodash/debounce';
  import autocompleteSearch from '../../../common/autocompleteSearch/components/autocompleteSearch';
  import uniqBy from 'lodash/uniqBy';
  import split from 'lodash/split';


  export default {
    data() {
      return {
        isChange: false,
        apiUrl: 'users/',
        quizUrl: '/quiz/assigned/',
        rangeDateStart: null,
        rangeDateEnd: null,
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        minDateStart: this.getMinDateStart(new Date()),
        maxDateStart: this.getMaxDateStart(new Date()),
        quizList: [],
        autocomplete: [],
        visible: true,
        targetBehaviour: null,
        quiz: null,
        quizSelectedToDelete: null,
        isModalVisible: false,
        isModalErrorVisible: false,
        masList: null,
        fastList: null,
        results: null,
        maxFast: 0,
        maxMas: 0,
        dataMas: null,
        dataFast: null,
        messageError: null,
        options: {
          pageHeader: 'assignedQuiz',
          initialPage: null,
          filterable: false,
          sortable: [],
          skin: 'table table-sm',
          withSearch: false,
          columns: [
            {
              key: 'createdAt',
              changed: false,
              headings: lang.get('protocol.create_date')
            },
            {
              key: 'creator',
              changed: false,
              headings: lang.get('quiz.created')
            },
            {
              key: 'specialist',
              changed: false,
              headings: lang.get('report.specialist')
            },
            {
              key: 'quizAssignedUnits',
              changed: true,
              headings: lang.get('quiz.assigned')
            },
            {
              key: 'description',
              changed: false,
              headings: lang.get('quiz.description')
            },
            {
              key: 'quiz',
              changed: false,
              headings: lang.get('quiz.typeQuiz')
            },
            {
              key: 'addToReport',
              changed: true,
              headings: lang.get('quiz.addToReport')
            },
            {
              key: 'action',
              changed: true,
              headings: ''
            }

          ],
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          },
          texts:{
            filterPlaceholder: lang.get('bids.type_the_procol_name_to_search'),
            noResults:lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table')
          },
          rowClassCallback: this.rowClassCallback,
          columnsClasses:{
            createdAt: this.isMobile? '': 'nowrap',
            creator: this.isMobile? '': 'nowrap',
            action:'table-actions',
            quizAssignedUnits: 'not-break hide-row',
            addToReport: 'text-center  hide-row',
          },
          templates: {
            createdAt: this.createdAt,
            creator: this.getCreatorName,
            specialist: this.getSpecialistName,
            quiz: this.typeQuiz,
            quizAssignedUnits: this.getQuizAssignedUnits
          },
          listRow: {
            createdAt:{
              headings: lang.get('protocol.create_date'),
              hasTemplate: true,
            },
            creator:{
              headings: lang.get('quiz.created'),
              hasTemplate: true,
            },
            quizAssignedUnits:{
              headings: lang.get('quiz.assigned'),
              hasTemplate: true,
            },
            description:{
              headings: lang.get('quiz.description'),
              hasTemplate: false,
            },
            quiz:{
              headings: lang.get('quiz.typeQuiz'),
              hasTemplate: true,
            },
            childList:{
              headings: "",
              hasTemplate: false,
            },

          },
          perPage: 10
        },
        therapist: true,
        isLoaded: false

      };
    },
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },

    components: {
      Paginate, Loader,TableView, BarChart, BarChartDataset, autocompleteSearch
    },

    provide () {
      return { parentValidator: this.$validator }
    },

    computed: {

      ...mapGetters('mobile', [
        'isMobile',
      ]),

      ...mapGetters('auth', [
        'isTherapist',
        'isCurator',
        'isClient',
        'isBCBA',
        'user',
      ]),

      rangeDateStartTimestamp() {
        return this.rangeDateStart ? moment(this.rangeDateStart).unix() +
            (Math.abs(this.rangeDateEnd.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE) : null;
      },
      rangeDateEndTimestamp() {
        return this.rangeDateStart ? moment(this.rangeDateEnd).unix() +
            (Math.abs(this.rangeDateEnd.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE) : null;
      },

      barChartDatasetMas() {
        return this.fetchBarDatasetForChartMas();
      },

      barChartDatasetFast() {
        return this.fetchBarDatasetForChartFast();
      },


    },

    created() {
      Validator.extend('check-period', {
        getMessage: attribute => lang.get('report.description_max_period', {attribute}),
        validate: () => {
          let date = new Date(this.rangeDateStart.getFullYear(),
              (this.rangeDateStart.getMonth() + 4),
              this.rangeDateStart.getDate(),
              this.rangeDateEnd.getHours(),
              this.rangeDateEnd.getMinutes(),
              this.rangeDateEnd.getSeconds(),
              this.rangeDateEnd.getMilliseconds()
          );
          return this.rangeDateEnd.getTime() <= date.getTime();
        }
      });
      this.getQuizList();
    },

    methods: {

      searchAutocomplete: debounce(
          async (search, vm) => {
            try {

              let response = await axios.get(vm.apiUrl + vm.clientId + '/quiz/target-behavior/search' +
                  '?search=' + search, {params: {
                    quizId: vm.quiz && vm.quiz.id ? vm.quiz.id : null
                  }
              });
              vm.autocomplete = uniqBy(response.data.data, 'name');

            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          },
          250,
      ),

      setProblemBehaviourValue(value) {
        this.targetBehaviour = value;

      },

      onChangeProblemBehaviour(search) {
        this.searchAutocomplete(search, this);
      },


      maxValue(answers){
        let answerMax = max(answers);
        return answerMax;

      },

      disabledCheckAnswer(row){

        let disabled = false;

        disabled = (row.quiz.id === 1) ? this.masList && row.id !== this.masList.quizId : this.fastList && row.id !== this.fastList.quizId;

        return disabled;

      },

      getDateStart() {
        let today = new Date();
        let minDateStart = new Date(today.getFullYear(), today.getMonth(),  (today.getDate() - 7));

        return minDateStart;
      },

      choseSpecialists(row,specialists){

        if(row.quiz.id === 1){

          if (specialists.addAnsweredToReport){

            if(!this.masList){
              this.masList = {
                quizType: row.quiz.id,
                quizId: row.id,
                unitIds: [specialists.id]
              };
            } else if(this.masList && row.id === this.masList.quizId){
              this.masList.unitIds.push(specialists.id)
            }

          } else{

            let indexSpecialists = findIndex(this.masList.unitIds, item => {return item=== specialists.id});

            this.masList.unitIds.splice(indexSpecialists, 1);
            if(!this.masList.unitIds.length){
              this.masList = null;
            }

          }


        }

        if(row.quiz.id === 2){
          if (specialists.addAnsweredToReport){

            if(!this.fastList){
              this.fastList = {
                quizType: row.quiz.id,
                quizId: row.id,
                unitIds: [specialists.id]
              };
            } else if(this.fastList && row.id === this.fastList.quizId){
              this.fastList.unitIds.push(specialists.id)
            }

          } else{

            let indexSpecialists = findIndex(this.fastList.unitIds, item => {return item === specialists.id});
            this.fastList.unitIds.splice(indexSpecialists, 1);

            if(!this.fastList.unitIds.length){
              this.fastList = null;
            }

          }

        }

      },

      listReportLength(list){
        let answerCount = filter(list, item => {
          return item.addAnsweredToReport
        });

        return answerCount.length
      },

      getMaxDateFinish: function(date) {
        let clientDateEnd = moment().tz(this.clientTimezone).add(-(moment().utcOffset()), 'm');
        let minDateEnd = clientDateEnd._d;
        return minDateEnd;
      },

      getMinDateStart: function (date) {
        let minDateStart = new Date((date.getFullYear() - 1), date.getMonth(),
            date.getDate());
        return minDateStart;
      },

      getMaxDateStart: function (date) {
        let maxDateStart = new Date(date.getFullYear(), date.getMonth(),
            date.getDate() + 1);
        return maxDateStart;
      },

      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      toLocaleDateTime: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
      },


      createdAt(h, row) {
        return this.toLocaleDate(row.createdAt.date);
      },

      rowClassCallback(row) {
        return ((this.isCurator && this.user.id === row.creator.id) || this.isBCBA) && !this.isMobile && row.quizAnsweredUnits.length  ? "" : "disable-child";
      },
      getCreatorName(h, row) {
        return row.creator.displayName;
      },

      getSpecialistName(h, row) {
        return row.specialist.displayName;
      },

      getQuizAssignedUnits(h, row) {
        let list = join(map(row.quizAssignedUnits, 'name'), ', ');
        return list;
      },



      typeQuiz(h, row) {
        return row.quiz.title;
      },

      async requestFunction (data) {
        return this.getAssignedQiuz(this.options.perPage, data.page, this.clientId, data.query);
      },

      getQuizList: async function(){
        try {

          let response = await axios.get(`${this.apiUrl}${this.clientId}/quiz/`);

          this.quizList = response.data.data.items;

          this.quizList.unshift({
            id: null,
            title: lang.get('report.all')
          });

          this.isLoaded = true;

        } catch (error) {
          console.dir(error);
          //this.$router.push({name: 'default'});
        }
      },

      onPaginationClick: async function(pageNum) {
        this.getAssignedQiuz(this.paginate.perPage, pageNum,
            this.clientId);
        this.onPaginationBtnClick(pageNum);
      },

      getAssignedQiuz: async function(perPage, page, clientId) {
        try {
          let targetBehaviourId = null;
          if(this.targetBehaviour){
            targetBehaviourId = filter(this.autocomplete, item => item.name === this.targetBehaviour)[0].id;
          }

          localStorage.setItem('currentPage', page);
          localStorage.setItem('currentPageHeader', 'assignedQuiz');

          let params = {
            perPage: perPage,
            page: page,
            startDate: this.rangeDateStartTimestamp,
            endDate: this.rangeDateEndTimestamp,
            quizId: this.quiz ? this.quiz.id : null,
            targetBehaviorId: targetBehaviourId,
          };

          let response = await axios.get(
              `${this.apiUrl}${clientId}${this.quizUrl}`, {
                params: params
              });

          let assignedQuiz = response;
          assignedQuiz.data.data.items.forEach(item => {
            item.isOpen = false;
            item.addToReport = false;
            item.quizAnsweredUnits.forEach(itemAnswered => {
              if(this.addAnsweredInlist(item.id, item.quiz.id, itemAnswered.id)){
                this.$set(itemAnswered, 'addAnsweredToReport', true);
              } else{
                this.$set(itemAnswered, 'addAnsweredToReport', false);
              }
              itemAnswered.isOpen = false;
            });
          });
          this.isChange = false;
          return assignedQuiz;

        } catch (error) {
          console.dir(error);
          //this.$router.push({name: 'default'});
        }
      },

      addAnsweredInlist(quizId, type, specialistsId){

        if(type === 1 && this.masList && this.masList.quizId === quizId){

          let checked = filter(this.masList.unitIds, item => item === specialistsId);

          return checked.length;
        }

        if(type === 2 && this.fastList && this.fastList.quizId === quizId){

          let checked = filter(this.fastList.unitIds, item => item === specialistsId);

          return checked.length;

        }

        return false;
      },

      applyFilter(){
        this.isChange = true;
        this.masList = null;
        this.fastList = null;
        this.results = null;
      },


      showDeletePopup(quiz) {
        this.quizSelectedToDelete = quiz;
        this.isModalVisible = true;
      },

      onModalClose() {
        this.isModalVisible = false;
      },

      onModalErrorClose(){
        this.isChange = false;
        this.isModalErrorVisible = false;
      },

      deleteQuiz: async function(quiz){
        this.isChange = false;
        this.isLoaded = false;
        try {

          await axios.delete(`${this.apiUrl}${this.clientId}/quiz/${quiz.quiz.id}/assign/${quiz.id}`);
          this.isChange = true;
          this.isLoaded = true;

        } catch (e) {

          if(e && e.data.code === 403){
            this.isLoaded = true;
            this.isChange = true;
            this.isModalErrorVisible = true;
          }

        }

      },

      getSpecialistIds(){
        let assignedQuiz = [];

        if(this.fastList){
          assignedQuiz.push({
            id: this.fastList.quizId,
            unitIds: this.fastList.unitIds
          })
        }

        if(this.masList){
          assignedQuiz.push({
            id: this.masList.quizId,
            unitIds: this.masList.unitIds
          })
        }

        return JSON.stringify(assignedQuiz);
      },


      showResult: async function(){

        if((this.fastList && (this.fastList.unitIds.length < 2 || this.fastList.unitIds.length > 3)) || (this.masList && (this.masList.unitIds.length < 2 || this.masList.unitIds.length > 3))){
          this.messageError = lang.get('quiz.errorResult');
          return;
        }

        this.messageError = "";

        try {


          let response = await axios.get(`${this.apiUrl}${this.clientId}${this.quizUrl}report/compare/`, {
            params: {
              "assignedQuiz": this.getSpecialistIds()
            }
          });

          this.results = response.data.data;

          setTimeout(() => {
            this.$refs.resultTable.scrollIntoView({ behavior: 'smooth'});
          }, 50);



        } catch (error) {
          this.isChange = false;
          this.messageError = error ? Object.values(error.data.errors)[0].message : null;
        }
      },

      exportQuiz: async function() {
        if((this.fastList && (this.fastList.unitIds.length < 2 || this.fastList.unitIds.length > 3)) || (this.masList && (this.masList.unitIds.length < 2 || this.masList.unitIds.length > 3))){
          this.messageError = lang.get('quiz.errorResult');
          return;
        }

        this.messageError = "";

        try {

          let response = await axios.get(`${this.apiUrl}${this.clientId}${this.quizUrl}pdf/compare/`,
              {
                responseType: 'blob',
                params: {
                  "assignedQuiz": this.getSpecialistIds()
                }
              }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', lang.get('quiz.quiz') + '.pdf');
            document.body.appendChild(link);
            link.click();
          });

        } catch (error) {
          console.dir(error);
          this.isChange = false;
          this.messageError = Object.values(error.data.errors)[0].message;
        }
      },

      exportSpecialistQuiz: async function(quizId, specialistsId) {

        try {

          let response = await axios.get(`${this.apiUrl}${this.clientId}${this.quizUrl}${quizId}/assignedUnit/${specialistsId}/pdf/`,
              {
                responseType: 'blob',
              }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', lang.get('quiz.quiz') + '_' + quizId  + '_' + specialistsId + '.pdf');
            document.body.appendChild(link);
            link.click();
          });

        } catch (error) {
          console.dir(error);
          this.isChange = false;
          this.messageError = Object.values(error.data.errors)[0].message;
        }
      },

      resultSpecialistQuiz: async function(quizId, specialistsId) {

        try {

          let response = await axios.get(`${this.apiUrl}${this.clientId}${this.quizUrl}${quizId}/assignedUnit/${specialistsId}/report/`);
          this.isChange = true;
          this.masList = null;
          this.fastList = null;
          this.results = [response.data.data];
          setTimeout(() => {
            this.$refs.resultTable.scrollIntoView({ behavior: 'smooth'});
          }, 50);

        } catch (error) {
          console.dir(error);
          this.isChange = false;
          this.messageError = Object.values(error.data.errors)[0].message;
        }
      },


      getRandomColor(i) {

        let letter = i * 80;
        let color = 'rgb('+letter+','+letter+','+letter+')' ;

        return color;
      },

      fetchBarDatasetForChartFast(){
        let dataFast = [], max =0;

        let fastData = filter(this.results, item => (item.quiz.id === 2));

        forEach(fastData, (result, index) => {

          let data = [], backgroundColor = null;
          let label = result.assignedQuizUnit.name;
          let labels = [];

          forEach(result.resultTable.title, (title,index) => {

            max = max < result.resultTable.totalScore[index] ?  result.resultTable.totalScore[index] : max;

            data.push(
                {
                  x: title,
                  y: result.resultTable.totalScore[index],
                },
            );
            labels.push(split(title, '   '));

          });
          backgroundColor = this.getRandomColor(index);

          dataFast.push(new BarChartDataset({data, label, labels, backgroundColor}));

        });

        this.maxFast = max ? max*1.2 : 0;

        this.dataFast = dataFast;

        return dataFast;
      },


      fetchBarDatasetForChartMas(){
        let dataMas = [], max = 0;

        let masData = filter(this.results, item => (item.quiz.id === 1));

        forEach(masData, (result, index) => {

          let data = [], backgroundColor = null;
          let label = result.assignedQuizUnit.name;
          let labels = [];



          forEach(result.resultTable.titles[0], (title,index) => {

            max = max < result.resultTable.totalScore[6][index] ?  result.resultTable.totalScore[6][index] : max;

            data.push(
                {
                  x: title,
                  y: result.resultTable.totalScore[6][index],
                },
            );
            labels.push(title);

          });
          backgroundColor = this.getRandomColor(index);

          dataMas.push(new BarChartDataset({data, label, labels, backgroundColor}));

        });

        this.maxMas = max ? max*1.2 : 0;
        this.dataMas = dataMas;


        return dataMas;
      },


    },
    watch: {
      rangeDateEnd(){
        this.isChange = false;
      },
      rangeDateStart(){
        this.isChange = false;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/modules/quiz/components/QuizList.vue